// Утилита: массовая инвалидация react-query кеша при смене активного заведения.
// Сбрасываем ВСЁ, что может зависеть от establishmentId, и оставляем только
// действительно глобальные запросы (список всех заведений, у которых нет привязки
// к выбранному тенанту).
import type { QueryClient } from '@tanstack/react-query';

const GLOBAL_KEYS = new Set<string>([
  'admin/ests',           // список всех заведений (используется сайдбаром + настройками)
  'admin/establishments', // то же самое, отдельный ключ на Users.tsx
]);

export function invalidateEstablishmentScoped(qc: QueryClient) {
  qc.invalidateQueries({
    predicate: (q) => {
      const key = String(q.queryKey[0] ?? '');
      if (GLOBAL_KEYS.has(key)) return false;
      return true;
    },
  });
}
